import React from "react";
import IconSvg from "../icon-svg/icon-svg";
import { AppIcon } from "../icon-svg/app-icon.model";
import "./search-input-text.css";

type Props = {
  label: string;
  value: string;
  onValueChange: (val: string) => void;
  onSearch: () => void;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  translate?: (s: string) => string;
};

const SearchInputText: React.FC<Props> = ({
  label,
  value,
  onValueChange,
  onSearch,
  type = "text",
  required = false,
  disabled = false,
  placeholder = "common.placeholder.search",
  translate = (s) => s,
}) => {
  return (
    <div className="search-input-text">
      <label>
        {translate(label)}
        {required ? "*" : ""}
      </label>
      <div className="input-container">
        {value && (
          <IconSvg
            path={AppIcon.CANCEL}
            className="clear-icon-svg text"
            onClick={() => onValueChange("")}
          />
        )}

        <IconSvg
          path={AppIcon.SEARCH}
          className="search-icon-svg text"
          onClick={onSearch}
        />

        <input
          type={type}
          placeholder={translate(placeholder)}
          value={value}
          onChange={(e) => onValueChange(e.target.value)}
          className="form-control input-field"
          required={required}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default SearchInputText;
